import { Guid } from 'guid-typescript'
import { RetornoApiGenerics } from 'models/Geral/RetornoApiGenerics'
import { RetornoDefault } from 'models/Geral/RetornoDefault'
import { CasasEntrada } from 'models/Viabilidade/CasasEntrada'
import { CasasSaida } from 'models/Viabilidade/CasasSaida'
import { CasasSimplificado } from 'models/Viabilidade/CasasSimplificado'
import { PdfDto } from 'models/Viabilidade/PdfDto'
import { DadosClonarViabilidade } from 'models/Viabilidade/DadosClonarViabilidade'
import api from 'services/api.service'

const urlBaseCasas = '/simulacaoCasas'

export const adicionarCasas = async (casasEntrada: CasasEntrada): Promise<RetornoDefault> => {
  const response = await api.post(`/simulacaoCasas`, casasEntrada)
  return response.data as RetornoDefault
}

export const modificarCasas = async (casasEntrada: CasasEntrada): Promise<RetornoDefault> => {
  const response = await api.put(`/simulacaoCasas`, casasEntrada)
  return response.data as RetornoDefault
}

export const buscarViabilidadesPorIdTerreno = async (idTerreno: Guid, idEmpreendimento?: Guid): Promise<CasasSimplificado[]> => {
  const params = {
    idTerreno: idTerreno.toString(),
    idEmpreendimento: !idEmpreendimento?.isEmpty() ? idEmpreendimento?.toString() : ''
  }

  const response = await api.get(`simulacaoCasas`, {
    params: params
  })
  const retorno = response.data as RetornoApiGenerics<CasasSimplificado>
  return retorno.data
}

export const buscarViabilidadePorId = async (idViabilidade: Guid): Promise<RetornoApiGenerics<CasasSaida>> => {
  const response = await api.get<RetornoApiGenerics<CasasSaida>>(`${urlBaseCasas}/${idViabilidade}`)
  return response.data
}

export const downloadViabilidadeCasas = async (idViabilidade: Guid): Promise<RetornoApiGenerics<PdfDto>> => {
  const response = await api.get<RetornoApiGenerics<PdfDto>>(`${urlBaseCasas}/${idViabilidade}/relatorio`)
  return response.data
}

export const clonarViabilidadeCasas = async (clonarEntrada: DadosClonarViabilidade): Promise<RetornoApiGenerics<CasasSaida>> => {
  const response = await api.post<RetornoApiGenerics<CasasSaida>>(`${urlBaseCasas}/${clonarEntrada.idViabilidade}/clone`, clonarEntrada)
  return response.data
}

export const excluirViabilidadeCasas = async (idViabilidade: Guid): Promise<RetornoDefault> => {
  const response = await api.delete(`simulacaoCasas`, { params: { idViabilidade: idViabilidade.toString() } })
  return response.data as RetornoDefault
}

export const tornarVigenteViabilidadeCasas = async (idViabilidade: Guid): Promise<RetornoApiGenerics<boolean>> => {
  const response = await api.patch<RetornoApiGenerics<boolean>>(`${urlBaseCasas}/${idViabilidade}/vigente`)
  return response.data
}
